import React from 'react';
import TitledCell from '../UI/TitledCell/TitledCell';
import ContentCell from '../UI/ContentCell/ContentCell';
import { Grid } from 'react-bootstrap';
import { StyledButton } from '../StyledPrimitives/StyledPrimitives';

import YoutubeVideo from '../UI/YoutubeVideo/YoutubeVideo';
import PlayNow from './PlayNow';
import GameSummary from './GameSummary';
import Screenshots from './Screenshots';
import TitledList from './TitledList';

const games = require('../../games.json');

const gameInfo = (props) => {

    const game = games.find((game) => game.id === props.match.params.game);

    if (!game) {
        return (
            <Grid><TitledCell title='No Such Game!'></TitledCell></Grid>
        );
    } else {
        return (
            <Grid>
                <ContentCell>
                    <GameSummary game={game}></GameSummary>
                </ContentCell>

                {game.gameLinks ? 
                    game.gameLinks.map(link => 
                        <ContentCell key={link.url}><StyledButton onClick={() => { window.location = link.url; }}>{link.text}</StyledButton></ContentCell>) : null}

                {game.playNow ? 
                    <TitledCell title='Play Now!'><PlayNow playNow={game.playNow}/></TitledCell> : null}

                {game.trailer ? 
                    <TitledCell title='Trailer'>
                        <YoutubeVideo title={game.trailer.title} url={game.trailer.url}></YoutubeVideo>
                    </TitledCell> : null}

                {game.screenshots ? 
                    <TitledCell title='Screenshots'>
                        <Screenshots screenshots={game.screenshots}></Screenshots>
                    </TitledCell> : null}

                {game.lessons ? <TitledList title='Lessons' ordered list={game.lessons}></TitledList> : null}

                {game.credits ? <TitledList title='Credits' list={game.credits}></TitledList> : null}

            </Grid>
        );
    }
};

export default gameInfo;


// WEBPACK FOOTER //
// ./src/components/GameInfo/GameInfo.js